module.exports = __webpack_public_path__ + "media/images/badge/fenomeno_secondary-c6264e110ee47020438d5ea2e56e1da0.png";